import { render, staticRenderFns } from "./TestGroups.vue?vue&type=template&id=31a27053&"
import script from "./TestGroups.vue?vue&type=script&lang=js&"
export * from "./TestGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports